




























import { Vue, Component } from 'vue-property-decorator'
import ChangePasswordDialog from './ChangePasswordDialog.vue'
import { AvailableResult, NativeBiometric } from 'capacitor-native-biometric'

@Component({
  components: {
    ChangePasswordDialog,
  },
  metaInfo: {
    title: 'Settings - Security',
  },
})
export default class Security extends Vue {
  changePasswordDialog = false
  biometricsSaved = false

  async mounted() {
    this.checkBiometricsSaved()
  }

  async checkBiometricsSaved() {
    const result: AvailableResult = await NativeBiometric.isAvailable()
    if (result.isAvailable) {
      try {
        // Check if biometrics are saved
        await NativeBiometric.getCredentials({
          server: 'worxstr.com',
        })
        this.biometricsSaved = true
      } catch (e) {
        this.biometricsSaved = false
      }
    }
  }

  async clearBiometrics() {
    await NativeBiometric.deleteCredentials({
      server: 'worxstr.com',
    })
    this.biometricsSaved = false
  }
}
